import { useReactiveStorageFlag } from "@services/useReactiveStorageFlag";
import { useStorageManager } from "@services/useStorageManager";

/**
 * Returns whether BrazeAI Operator™ debug mode is enabled, reacting to changes
 * made through the storage manager so toggling it (e.g. from the
 * OperatorDebugMenu) immediately re-renders consumers such as the green
 * `data-operator-description` highlight.
 */
export const useIsOperatorDebugModeEnabled = (): boolean => {
  const storageManager = useStorageManager();
  return useReactiveStorageFlag(storageManager.KEYS.ENABLE_OPERATOR_DEBUG_MODE);
};
